export default {
    pageTitle: 'Activations',
    orderNumber: 'Order #',
    license: {
        unactivated: 'unactivated licenses',
        activate: 'Activate a new license',
        order_number: 'Order number',
    },
    form: {
        androidVersion: 'Android version',
        phoneModel: 'Phone model',
        productSerialNumber: 'AFS key',
    },
    name: 'Activations',
    list: {
        afsVersion: 'AFS version',
        date: 'Activation date',
        deviceSerialNumber: 'Device serial number',
        firmwareVersion: 'Firmware version',
        type: 'License type',
    },
};
